export default __webpack_public_path__ + "static/screenshot_japan-d6e36a70cd27fa624e8c40cdb99833a9.png";